import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  initDataUser,
  swipeBehavior,
  viewport,
} from '@telegram-apps/sdk-react';
import { checkIsPromoterRequest } from '@helpers/checkIsPromoterRequest.helper.js';
import { useAppProviderFacade } from '@providers/hooks/useAppProvider.facade.js';
import { useThemeParams } from '@hooks/features/useThemeParams.hook.js';

export function AppProvider({ children }) {
  const { id } = initDataUser();
  const { i18n } = useTranslation();

  const {
    user,
    fetchUser,
    setUser,
    setEventAvailable,
    setLangLoading,
    setLangError,
    setRequestPath,
  } = useAppProviderFacade();

  useEffect(() => {
    const { isPromoterRequest, user, isEventAvailable } =
      checkIsPromoterRequest();

    if (isPromoterRequest) {
      setEventAvailable(isEventAvailable);
      setUser(user);
    } else if (id) {
      fetchUser(id);
    }
  }, [fetchUser, setUser, id, setEventAvailable, setRequestPath]);

  useEffect(() => {
    if (user?.formattedLang) {
      i18n
        .changeLanguage(user.formattedLang)
        .then(() => setLangLoading(false))
        .catch(() => setLangError('Error. Try again later'));
    }
  }, [user?.formattedLang, i18n, setLangLoading, setLangError]);

  useEffect(() => {
    swipeBehavior.disableVertical.ifAvailable();
  }, []);

  useEffect(() => {
    if (viewport.isFullscreen()) return;
    viewport.requestFullscreen.ifAvailable();
  }, []);

  useThemeParams();

  return children;
}
